import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

const SEO = ({
  description,
  lang,
  meta,
  title,
  canonicalUrl,
  cards,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  // Setup general meta description
  const metaDescription = description || site.siteMetadata.description
  const metaTitle = title || site.siteMetadata.title

  // Start building META
  const metaData = [{
    name: 'description',
    content: metaDescription,
  }]

  if( cards ) {
    // Build general card data
    const generalCard = cards.find( card => card.slice_type === 'general_card' )

    if( generalCard ) {
      metaData.push({
        property: 'og:title',
        content: generalCard.primary.general_title.text || metaTitle,
      },
      {
        property: 'og:description',
        content: generalCard.primary.general_description.text || metaDescription,
      },
      {
        property: 'og:url',
        content: canonicalUrl,
      },
      {
        property: 'og:image',
        content: generalCard.primary.general_image.url,
      },
      {
        property: 'og:type',
        content: generalCard.primary.general_type.text,
      },
      {
        property: 'og:locale',
        content: generalCard.primary.general_locale.text,
      })
    }

    // Build twitter card data
    const twitterCard = cards.find( card => card.slice_type === 'twitter_card' )

    if( twitterCard ) {
      // Check for twitter image, add to data as needed
      if( twitterCard.primary.twitter_image && twitterCard.primary.twitter_image.url ) {
        metaData.push({
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:image',
          content: twitterCard.primary.twitter_image.url,
        })
      } else {
        metaData.push({
          name: 'twitter:card',
          content: 'summary',
        })
      }

      // Add general twitter data
      metaData.push({
        name: 'twitter:creator',
        content: twitterCard.primary.twitter_handle || site.siteMetadata.twitter_author,
      },
      {
        name: 'twitter:title',
        content: twitterCard.primary.twitter_title.text || metaTitle,
      },
      {
        name: 'twitter:description',
        content: twitterCard.primary.twitter_description.text || metaDescription,
      })
    }
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={ title }
      titleTemplate={ `%s | ${ site.siteMetadata.title }` }
      meta={ metaData.concat( meta ) }
    >
      {/* <script type="text/javascript" src="https://www.bugherd.com/sidebarv2.js?apikey=a01pqhxedcwlpj7t2rxpfw" async="true"></script> */}
    </Helmet>
  )
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf( PropTypes.object ),
  title: PropTypes.string.isRequired,
  cards: PropTypes.array,
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  cards: [],
}

export default SEO
